<template>
  <v-container>
    <v-row class="my-8">
      <v-col cols="12" md="4" offset-md="4">
        <ValidationObserver ref="observer">
          <v-form @submit.prevent="submit()">
            <h2>{{ this.whitelabel.authentication.resetPassword.title }}</h2>
            <ValidationProvider
              :id="whitelabel.authentication.resetPassword.fieldName"
              v-slot="{ errors }"
              :name="whitelabel.authentication.resetPassword.fieldName"
              :rules="whitelabel.authentication.resetPassword.validation"
            >
              <v-text-field
                v-model="uuid"
                :error-messages="
                  errors.length
                    ? whitelabel.authentication.resetPassword.validationMessage
                    : null
                "
                :label="whitelabel.authentication.resetPassword.fieldTitle"
              />
            </ValidationProvider>

            <v-btn
              rounded
              depressed
              large
              type="submit"
              color="primary"
              class="mt-8 mx-auto"
              :loading="buttonLoading"
            >
              <span>{{
                this.whitelabel.authentication.resetPassword.buttonText
              }}</span>
            </v-btn>
          </v-form>
        </ValidationObserver>
      </v-col>
    </v-row>
    <SuccessSnackbar v-model="showAlert" :message="alertMessage" />
    <ErrorSnackbar v-model="showError" />
  </v-container>
</template>

<script>
  import SuccessSnackbar from '../common/SuccessSnackbar.vue';
  import ErrorSnackbar from '../common/ErrorSnackbar.vue';
  import { formHelperMixin } from '../../mixins/form-helper-mixin';
  import { FORGOT_PASSWORD_MUTATION } from '../../constants/graphql/users';

  export default {
    name: 'ForgotPassword',
    metaInfo() {
      return {
        link: [
          {
            rel: 'canonical',
            href: this.whitelabel.canonicalUrls.forgotPassword,
          },
        ],
      };
    },
    components: {
      SuccessSnackbar,
      ErrorSnackbar,
    },
    mixins: [formHelperMixin],
    data() {
      return {
        uuid: '',
        showAlert: false,
        alertMessage: null,
      };
    },
    methods: {
      submit() {
        this.$refs.observer.validate().then(valid => {
          if (valid) {
            this.buttonLoading = true;
            this.sendResetRequest();
          } else {
            const errors = this.$refs.observer.ctx.errors;
            document
              .getElementById(
                Object.keys(errors).find(field => errors[field].length)
              )
              .scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        });
      },
      sendResetRequest() {
        this.$apollo
          .mutate({
            mutation: FORGOT_PASSWORD_MUTATION,
            variables: {
              authenticationValue: this.uuid,
              authenticationField:
                this.whitelabel.authentication.resetPassword.fieldName,
            },
          })
          .then(result => {
            this.buttonLoading = false;
            this.alertMessage =
              this.whitelabel.authentication.resetPassword.successMessage;
            this.showAlert = true;
          })
          .catch(error => {
            this.displayError();
            throw error;
          });
      },
    },
  };
</script>
